<template>
    <div>
        <div v-if="user">
            <nav class="navbar navbar-expand-lg navbar-light bg-white p-0">
                <div class="navbar-brand float-none">
                    <!--            Logo-->
                    <a href="#">
                        <img src="../../assets/logo.png" alt="KRBS LOGO" class="navbar-logo">
                    </a>

                   <div class="mx-auto align-middle p-0">
                       <div class="row" v-if="announcements.length">`
                           <div class="col col-sm-4 offset-4 border-announcement text-small font-weight-bolder p-2"
                                :class="'bg-' +  announcement.announcement_type.code"
                                v-if="announcement.announcement_type"
                           >
                               {{ announcement.message }}
                           </div>
                       </div>
                   </div>

                </div>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse pr-4 float-right" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item dropdown bg-white" v-if="user">
                            <a class="nav-link dropdown-toggle p-0 pr-2 bg-white" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div class="float-left text-small">
                                    {{ `${user.name.charAt(0)}. ${user.last_name}` }}
<!--                                    <hr class="m-0"/>-->
<!--                                    <small>{{ user.positions.map(p => p.short_name).join('/')}}</small>-->
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                <!--                        <div class="dropdown-divider"></div>-->
<!--                                <button role="button" class="dropdown-item p-1" @click="logout">Change Password</button>-->

                                <router-link class="dropdown-item px-2" role="button"
                                             :to="{ name: 'ChangePassword' }"
                                >
                                    Change Password
                                </router-link>

                                <button role="button" class="dropdown-item px-2" @click="logout">Logout</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-online-exam-red">
            <div class="collapse navbar-collapse" id="nav-links">
                <ul class="nav nav-tabs mr-auto border-bottom-0 pl-2 text-small" id="list1-tab1" role="tablist">

<!--                  isManning || isManningAdmin || isDesignatedManning-->
                  <li class="nav-item" v-if="isPrincipal || (user.manning_id == 1 && (isManning || isManningAdmin || isDesignatedManning)) || guest ">
                    <router-link :to="{name: 'Principal' }"
                                 tag="button"
                                 class="nav-link bg-online-exam-red"
                                 :class="{'active': isActiveRoute('Principal', ['MasterList'])}"
                                 role="tab"
                                 data-toggle="list"
                    >
                      Dashboard
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                        :to="{name: 'CrewIndex' }"
                        tag="button"
                        class="nav-link bg-online-exam-red"
                        :class="{'active': isActiveRoute('MasterList')}"
                        role="tab"
                        data-toggle="list"
                        @click="clearCrewList"
                    >
                      Master List
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                        :to="{name: 'OBListingWithEarMarkedRelievers'}"
                        tag="button"
                        class="nav-link bg-online-exam-red"
                        :class="{'active': isActiveRoute('OBListingWithEarMarkedRelievers')}"
                        role="tab"
                        data-toggle="list">
                      Crew Change
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                                 :to="{name: 'GenerateIMOCrewList'}"
                                 tag="button"
                                 class="nav-link bg-online-exam-red"
                                 :class="{'active': isActiveRoute('ReportsIndex')}"
                                 role="tab"
                                 data-toggle="list">
                      Reports
                    </router-link>
                  </li>
                  <li class="nav-item">

                    <router-link
                        v-if="isSystemAdmin"
                        :to="{name: 'UserIndex' }"
                        tag="button"
                        class="nav-link bg-online-exam-red"
                        :class="{'active': isActiveRoute('Admin')}"
                        role="tab"
                        data-toggle="list"
                    >
                      Admin
                    </router-link>
                  </li>
                        <CrewActivityUpload v-if="isSystemAdmin"></CrewActivityUpload>
                        <SafeCrewActivityUpload v-if="isSystemAdmin"></SafeCrewActivityUpload>
                </ul>
                <form class="form-inline my-2 my-lg-0" @submit.prevent="searchCrew">
                  <div class="input-group" style="width: 350px;">
                    <input
                        type="text"
                        class="form-control form-control-xs"
                        placeholder="Search Crew Here"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        v-model="crewSearchParam.searchValue"
                    >
                    <div class="input-group-append">
                      <button type="submit" class="input-group-text input-group-append">
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                </form>
            </div>
        </nav>
    </div>

</template>

<script>

    import { mapGetters, mapActions, mapState } from 'vuex';
    import { vueAppMixin } from "@/mixins/vueAppMixin";
    import { crewMixin } from "@/mixins/crewMixin";
    import { gateMixin } from "@/mixins/gateMixin";
    // import axios from "axios";
    import CrewActivityUpload from "@/components/sub_components/Fixes/CrewActivityUpload";
    import SafeCrewActivityUpload from "@/components/sub_components/Fixes/SafeCrewActivityUpload";

    export default {
        name: "Navbar",
        components: { CrewActivityUpload, SafeCrewActivityUpload },
        mixins: [ vueAppMixin, crewMixin, gateMixin ],
        data() {
            return {
                announcement: {
                    message: '',
                    type: ''
                },
            }
        },

        methods: {
            ...mapActions([
                'pullUserDetails',
                'clearStorage',
                'getCrewList',
                'setGlobalSearchValue',
                'clearCrewList'
            ]),

            async searchCrew() {
                this.crewSearchParam.searchKey = 'all';
                this.crewSearchParam.rank = 0;
                this.crewSearchParam.manning = 0;
                this.crewSearchParam.natl = 0;
                this.crewSearchParam.pooling = 0;
                this.crewSearchParam.crewStatus = 1;
                this.pagination.currentPage = 1;

                let params = {
                    page: 1,
                    searchKey: this.crewSearchParam.searchKey,
                    searchValue: this.crewSearchParam.searchValue,
                    manning: this.crewSearchParam.manning,
                    rank: this.crewSearchParam.rank,
                    natl: this.crewSearchParam.natl,
                    pooling: this.crewSearchParam.pooling,
                    activityCode: this.crewSearchParam.activityCode,
                    crewStatus: 1
                };
                await this.getCrewList(params);
                this.$forceUpdate();
                this.$router.push({ name: 'CrewIndex' });
            },

            async logout() {
                await this.clearStorage();
                this.$router.push({ name: 'Login'});
            },

            async fetchAnnouncements() {
                const self = this
                this.$store.dispatch('AnnouncementModule/fetchAnnouncements').then(() => {
                    if (self.announcements) self.switchAnnouncement()
                })
            },

            switchAnnouncement() {
                let i = 0

                this.announcement = this.announcements[i]

                setInterval(() => {
                    this.announcement = this.announcements[i++]
                    if (i > this.announcements.length -1) {
                        i = 0
                    }
                }, 3000)
            },

            async initializeData() {
                if(!this.user) {
                    this.pullUserDetails();
                }

                // await this.fetchAnnouncements();
            }
        },

        computed: {
            ...mapGetters([
                'user',
                'crewSearchParam',
                'pagination',
            ]),
            ...mapState({
                announcements: (state) => {
                    return state.AnnouncementModule.announcements;
                },
            }),
        },

        created() {
            this.initializeData();
        },
    }
</script>

<style scoped>

    .navbar-logo {
        width: 20%;
        height: 100%;
        float: left;
    }

    .padding-1p {
        padding-top: 1%;
        padding-bottom: 1%;
    }

    .mr-1p {
        left: -95%;
        /*right: 20% !important;*/
    }

    .border-announcement {
        border: 1px solid maroon;
        border-radius: 5px;
    }

    ul > li,
    ul > li > button {
        border-radius: 3px !important;
        color: white;
        margin: 0 1px;
    }
   ul > li > button:focus,
    ul > li > button:active {
        outline:none;
    }

    li>button.active, .nav-tabs .nav-link.active {
        background: white !important;
        font-weight: bold;
        color: #c53030 ;
    }
    .bg-online-exam-red {
        background-color: #c53030;
    }

    /*@media (max-width: 1199.98px) {*/

    /*}*/

    /*@media (max-width: 1200px) {*/

    /*}*/

</style>
